import { atom, useAtomValue, useSetAtom } from "jotai";

export const hasVotedAtom = atom ( {} );

export const useSetHasVotedAtom = () => {
	return useSetAtom ( hasVotedAtom );
};

export const useGetHasVotedAtom = () => {
	return useAtomValue ( hasVotedAtom );
};
